import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import { includes } from 'lodash-es';
import { isHuaweiDevice } from '~/core/functions';
import { ReservedQueryKey } from '~/core/enums/routing';
import { APP_LINKS } from '~/core/constants';
var KnownToNextPath = {
  Lpu: 'lpu',
  Vrach: 'vrach'
};
function isKnownToNextPath(value) {
  return includes(KnownToNextPath, value);
}
export var useAppLink = function useAppLink($route) {
  var route = $route !== null && $route !== void 0 ? $route : useRoute();
  var DEEP_LINK_HOST = 'medtochka://app';
  var storeLink = computed(function () {
    return isHuaweiDevice() ? APP_LINKS.appGalleryStoreLink : APP_LINKS.universalStoreLink;
  });
  var getToNextDeeplink = function getToNextDeeplink() {
    var _route$params$next;
    var url = decodeURIComponent(((_route$params$next = route.params.next) !== null && _route$params$next !== void 0 ? _route$params$next : '').toString());
    var isTelemed = url.includes('#filter=telemed');
    var match = url.match(/\/([^/]+)\/(\d+)/);
    var slug = match === null || match === void 0 ? void 0 : match[1];
    var id = Number(match === null || match === void 0 ? void 0 : match[2]);
    if (slug && isKnownToNextPath(slug) && id > 0) {
      switch (slug) {
        case KnownToNextPath.Vrach:
          {
            return "/doctor/".concat(id, "/").concat(isTelemed ? 'telemed/' : '');
          }
        case KnownToNextPath.Lpu:
          {
            return "/lpu/".concat(id);
          }
      }
    }
    return '/';
  };
  var deepLinkPath = computed(function () {
    switch (route.name) {
      case 'medcard':
        return '/medcard/';
      case 'appointments-id':
        return "/appointments/".concat(route.params.id, "/");
      case 'appointments-id-transfer':
        return "/appointments/".concat(route.params.id, "/transfer/");
      case 'analyses-id':
        return "/analyses/".concat(route.params.id, "/");
      case 'rates-type-id':
        return "/rates/".concat(route.params.type, "/").concat(route.params.id, "/");
      case 'rates-type-id-chat':
        return "/rates/".concat(route.params.type, "/").concat(route.params.id, "/chat/");
      case 'profile':
        return '/profile/';
      case 'profile-family-uuid':
        return "/profile/family/".concat(route.params.uuid, "/edit/");
      case 'path-without-handling':
        return '/path-without-handling/';
      case 'appointments-id-creation':
        return "/appointments/".concat(route.params.id, "/creation/");
      case 'chat-doctor-payment-wait':
        return '/chat/doctor/payment-wait/';
      case 'to-next':
        {
          return getToNextDeeplink();
        }
      case 'appointments-id-payment-wait':
        return "/appointments/".concat(route.params.id, "/payment-wait/");
      case 'appointments-id-pay':
        return "/appointments/".concat(route.params.id, "/pay/");
      default:
        return '/';
    }
  });
  /*
  * Нормализация search - костыль для авторизации через WB ID, которые ломают query string при редиректе
  * */
  var normalizedSearch = decodeURIComponent(window.location.search).replace(/\?/g, function (match, index) {
    return index === 0 ? '?' : '&';
  });
  var normalizeSearch = Boolean(route.query && route.query[ReservedQueryKey.AppWbAuth]);
  var query = new URLSearchParams(normalizeSearch ? normalizedSearch : window.location.search);
  query.delete(ReservedQueryKey.OpenApp);
  var queryString = query.toString();
  var deepLink = computed(function () {
    return queryString ? DEEP_LINK_HOST + deepLinkPath.value + "?".concat(queryString) : DEEP_LINK_HOST + deepLinkPath.value;
  });
  return {
    storeLink: storeLink,
    deepLink: deepLink
  };
};